module.exports = __webpack_public_path__ + "img/graphQl.5022f465.svg";